import { render, staticRenderFns } from "./DecisionStart.vue?vue&type=template&id=184deba2&"
import script from "./DecisionStart.vue?vue&type=script&lang=js&"
export * from "./DecisionStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports